import { Injectable } from '@angular/core';
import { BaseQuery } from "../base/base.query";
import { LanguageStore } from "./language.store";

@Injectable({ providedIn: 'root' })
export class LanguageQuery extends BaseQuery {

    constructor(store: LanguageStore) {
        super(store);
    }
}
